import type { AnalyticsRange } from '../../../../shared/types/analytics'
import { useTranslation } from 'react-i18next'

interface AnalyticsFiltersProps {
  range: AnalyticsRange
  onRangeChange: (range: AnalyticsRange) => void
  includeBots: boolean
  onIncludeBotsChange: (includeBots: boolean) => void
}

const RANGE_VALUES: AnalyticsRange[] = ['1d', '7d', '30d', '90d']

/** 기간 선택 + 봇 포함 토글 */
export default function AnalyticsFilters({
  range,
  onRangeChange,
  includeBots,
  onIncludeBotsChange,
}: AnalyticsFiltersProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div
        role="group"
        aria-label={t('analyticsPage.rangeGroup')}
        className="inline-flex rounded-xl border border-gray-300 bg-white p-1 dark:border-gray-600 dark:bg-gray-800"
      >
        {RANGE_VALUES.map(value => (
          <button
            key={value}
            type="button"
            aria-pressed={range === value}
            onClick={() => onRangeChange(value)}
            className={`rounded-lg px-3 py-1.5 text-sm font-medium transition ${
              range === value
                ? 'bg-primary-600 text-white'
                : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
            }`}
          >
            {t(`analyticsPage.range${value}`)}
          </button>
        ))}
      </div>

      <label className="inline-flex cursor-pointer items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
        <input
          type="checkbox"
          checked={includeBots}
          onChange={event => onIncludeBotsChange(event.target.checked)}
          className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 dark:border-gray-600"
        />
        {t('analyticsPage.includeBots')}
      </label>
    </div>
  )
}
